<template>
  <div class="order">
    <div class="order_nav">
      <navbar
        title="修改库存"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="all">
      <div class="box">
        <van-row class="goods">
          <van-col span="24" class="goods_info">
            <div class="img">
              <img :src="detailInfo.thumb" />
              <p v-if="detailInfo.status == 7">已售罄</p>
              <p v-if="detailInfo.status == 1" class="normal">已上架</p>
            </div>
            <p class="name">{{ detailInfo.name }}</p>
            <p class="money">
              采购价：<span
                >￥{{ detailInfo.min_cost_price }}-{{
                  detailInfo.max_cost_price
                }}</span
              >
            </p>
            <p class="stock">
              库存：<span>{{ detailInfo.inventory }}</span>
            </p>
          </van-col>
        </van-row>
        <van-row
          class="spec"
          v-for="(item, index) in detailInfo.sku"
          :key="index"
        >
          <van-col span="24" class="spec_name">{{
            item.specification_name
          }}</van-col>
          <van-col span="24" class="price">
            <span class="money"
              >采购价：<span>￥{{ item.cost_price }}</span></span
            >
            <van-cell-group>
              <van-field
                v-model="item.inventory"
                type="digit"
                label="库存"
                placeholder="请输入"
              />
            </van-cell-group>
          </van-col>
        </van-row>
      </div>
    </div>
    <van-row class="footer">
      <van-col span="24">
        <btn
          :btntext="'保存修改'"
          :btnwidth="'34.3rem'"
          :height="'4.4rem'"
          :bgcolor="'linear-gradient(to right, #fc740c, #f41a3c)'"
          :borderradius="'2.2rem'"
          :btncolor="'#fff'"
          :fontsize="'1.6rem'"
          @btnClick="save"
        />
      </van-col>
    </van-row>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      detailInfo: {},
    };
  },
  created() {
    this.getInfo();
    this.handleInput();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    handleInput() {
      window.addEventListener("resize", function () {
        window.setTimeout(function () {
          document.activeElement.scrollIntoView(false);
        }, 1);
      });
    },
    getInfo() {
      this.$api
        .post("/ongoods/member/goods/supplier/goods/detail", {
          id: this.$route.query.id,
        })
        .then((res) => {
          this.detailInfo = res;
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    save() {
      this.$api
        .post("ongoods/member/goods/supplier/update/sku/inventory", {
          sku: this.detailInfo.sku,
        })
        .then((res) => {
          this.$router.replace({
            path: "/purchaseSupplier/result",
            query: {
              type: 2,
            },
          });
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.order {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .order_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .all {
    padding: 10rem 1.6rem 6.5rem;
    box-sizing: border-box;
    height: 100%;

    .box {
      height: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;

      .goods {
        height: 11rem;
        border-radius: 0.8rem;
        background: #fff;
        margin-bottom: 1.2rem;
        padding: 0;

        .goods_info {
          height: 10.2rem;
          font-size: 1.2rem;
          color: #333;
          padding: 2rem 1.2rem 1.2rem;
          box-sizing: border-box;
          position: relative;

          .img {
            width: 7rem;
            height: 7rem;
            float: left;
            position: relative;

            img {
              width: 7rem;
              height: 7rem;
            }

            p {
              width: 7rem;
              padding: 0;
              color: #fff;
              font-size: 1.1rem;
              height: 2rem;
              line-height: 2rem;
              text-align: center;
              position: absolute;
              left: 0;
              bottom: 0;
              background: rgba(219, 0, 0, 0.6);
            }

            .normal {
              background: rgba(0, 0, 0, 0.6);
            }
          }

          p {
            height: 2rem;
            line-height: 2rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding-left: 1.2rem;
          }

          .name {
            font-weight: 700;
            font-size: 1.4rem;
          }

          .money {
            margin: 0.6rem 0;
            span {
              font-size: 1.4rem;
              color: #ff4747;
              font-weight: 700;
            }
          }

          .stock {
            height: 1.8rem;
            line-height: 1.8rem;

            span {
              font-size: 1.4rem;
              font-weight: 700;
            }
          }
        }

        .btns {
          text-align: right;
          padding: 0 1.2rem;
        }
      }

      .spec {
        min-height: 9.6rem;
        border-radius: 0.8rem;
        background: #fff;
        padding: 1.6rem 1.8rem 1.6rem 1.6rem;
        box-sizing: border-box;
        margin-top: 1.2rem;

        .spec_name {
          color: #333;
          font-size: 1.4rem;
          font-weight: 700;
          line-height: 2rem;
          margin-bottom: 1.2rem;
        }

        .price {
          height: 3.2rem;
          position: relative;

          .money {
            height: 2rem;
            line-height: 2rem;
            color: #999;
            font-size: 1.2rem;
            display: inline-block;

            span {
              height: 2rem;
              line-height: 2rem;
              display: inline-block;
              color: #ff4747;
              font-size: 1.4rem;
              font-weight: 700;
            }
          }

          /deep/.van-cell-group {
            width: 12.8rem;
            height: 3.2rem;
            padding: 0 0.8rem 0 1.2rem;
            background: #f5f6f7;
            border-radius: 0.4rem;
            border: none;
            position: absolute;
            right: 0;
            bottom: 0;

            .van-cell {
              padding: 0;
              height: 3.2rem;
              line-height: 3.2rem;
              background: #f5f6f7;
              border-radius: 0.4rem;
              border: none;

              .van-field__label {
                width: 3.2rem;
                margin-right: 0.8rem;
                box-sizing: border-box;
              }

              .van-field__control {
                text-align: center;
              }
            }
          }
        }
      }
    }
  }

  .footer {
    height: 5.2rem;
    padding: 0.4rem 1.6rem 0;
    background: #fff;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}
</style>




